angular.module('galilai.creator').factory('videoService', function ($timeout, $rootScope) {

    let videoCache = {};

    let startedDownload = {}

    async function download(videoUrl) {
        if (startedDownload[videoUrl]) {
            if (!videoCache[videoUrl]) {
                // Monitor the download and wait for it to finish
                return new Promise((resolve, reject) => {
                    const interval = setInterval(() => {
                        if (videoCache[videoUrl]) {
                            clearInterval(interval);
                            resolve(videoCache[videoUrl]);
                        }
                    }, 100);
                });
            }
            return;
        }
        startedDownload[videoUrl] = true;
        // Check if the video is already in the cache
        if (videoCache[videoUrl]) {
            return videoCache[videoUrl]; // Return cached Blob URL and duration
        }

        // Fetch the video file as a Blob
        const response = await fetch(videoUrl);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        // Extract video duration
        const duration = await getVideoDuration(blobUrl);

        // Store in cache
        videoCache[videoUrl] = {
            url: blobUrl,
            duration: duration,
        }

        return videoCache[videoUrl];
    }

    function checkAllVideosCached(cb) {
        if (!startedDownload || Object.keys(startedDownload).length === 0) {
            cb();
            return;
        }
        let allCached = true;
        for (let videoUrl in startedDownload) {
            if (!videoCache[videoUrl]) {
                allCached = false;
                break;
            }
        }
        if (allCached) {
            cb();
        } else {
            $timeout(() => checkAllVideosCached(cb), 200);
        }
    }

    function downloadAndWait(videos) {
        let promises = videos.map(video => download(video));
        return Promise.all(promises)
    }

    function hasPendingVideos(videos) {
        for (let video of videos) {
            if (!videoCache[video]) {
                return true;
            }
        }
        return false;
    }

    function getVideoDuration(blobUrl) {
        return new Promise((resolve, reject) => {
            const video = document.createElement("video");
            video.preload = "metadata";
            video.src = blobUrl;

            video.onloadedmetadata = () => {
                resolve(video.duration); // Return duration in seconds
            };

            video.onerror = () => reject("Error loading video metadata.");
        });
    }

    function getCachedVideo(videoUrl) {
        if (!videoCache[videoUrl] && !startedDownload[videoUrl]) {
            download(videoUrl);
        }
        if (videoCache[videoUrl]) {
            return videoCache[videoUrl].url
        }
        return videoUrl;
    }

    function getCachedVideoDuration(videoUrl) {
        if (videoCache[videoUrl]) {
            return videoCache[videoUrl].duration;
        }
        if (videoUrl.startsWith('blob:')) {
            for (let url in videoCache) {
                if (videoCache[url].url === videoUrl) {
                    return videoCache[url].duration;
                }
            }
        }
        return 0;
    }

    function getFullSizeVideo(videoUrl) {
        // If starts with blob, return the original URL
        if (videoUrl.startsWith('blob:')) {
            for (let url in videoCache) {
                if (videoCache[url].url === videoUrl) {
                    return url;
                }
            }
        }
        return videoUrl.replace('_small', '');
    }

    return {
        hasPendingVideos: hasPendingVideos,
        checkAllVideosCached: checkAllVideosCached,
        downloadAndWait: downloadAndWait,
        download: download,
        getCachedVideo: getCachedVideo,
        getCachedVideoDuration: getCachedVideoDuration,
        getFullSizeVideo: getFullSizeVideo,
    };
});